import React, { Component, createElement } from 'react';
import { func, bool } from 'prop-types';
import AutoScrollContext from 'contexts/AutoScroll/AutoScrollContext';

class Pausable extends Component {
    static propTypes = {
        component: func.isRequired,
        scrolling: bool.isRequired,
    };

    shouldComponentUpdate(nextProps) {
        return !nextProps.scrolling;
    }

    render() {
        const { component, ...otherProps } = this.props;
        return createElement(component, otherProps);
    }
}

export default ConnectedComponent => props => (
    <AutoScrollContext.Consumer>
        {scrolling => (
            <Pausable
                {...props}
                component={ConnectedComponent}
                scrolling={scrolling}
            />
        )}
    </AutoScrollContext.Consumer>
);
